
let bg = document.querySelector('#bg-container');
let navigation = document.querySelector('#pagination')

function getCurrentSlide() {
    return $.scrollify.current()[0];
}


window.goToSection = function(name) {
    $.scrollify.move(name)
}
function moveBg(index) {
    bg.dataset.current =  index;
    
    let activeCard = document.querySelector('.step-box.active');
    
    if(activeCard != null) {
        activeCard.classList.remove('active')
        activeCard.classList.add('out')
    }
    
    if(index == 0 ) {
        document.querySelector('#step-0').classList.add('start')
    }
    else {
        document.querySelector('#step-0').classList.remove('start')
    }
}

function toggleCard(index) {
    let activeCard = getCurrentSlide().querySelector('.step-box');
    
    if(activeCard != null) {
        activeCard.classList.add('active')
        activeCard.classList.remove('out')
    }
}

function updateNavigation(index) {
    console.log(index)
    //$.scrollify.move()
    navigation.querySelector('.active').classList.remove('active')
    navigation.children[7 - index].children[0].classList.add('active')
}

$(function() {
  $.scrollify({
    section : ".step",
    sectionName : "section-name",
    interstitialSection: '.no-step',
    //offset: 50,
    overflowScroll: true,
    scrollbars: true,
    setHeights: true,
    scrollSpeed: 1000,
    before:function(index, sections) {
        if(index < 8) {
            moveBg(index)
        }
    },
    after: function(index, sections) {
        if(index < 8) {
            toggleCard(index);
            updateNavigation(index);
        }
    }
  });
});